export default __webpack_public_path__ + "static/media/logoHebraicodabiblia.555e6b31.png";